module.exports = __webpack_public_path__ + "static/media/hall-PD.56fbe280.svg";